import { SET_VENUE_DATA } from "../const";
import { SELECTED_VENUE_ID } from "../reducers/selectedVenueId";
import { IVenueReducerState } from "../reducers/venue";

export const setVenueData = (dataKey: keyof IVenueReducerState, venueData: unknown) => {
    console.log("setting venue data", dataKey, venueData);
    return {
        type: SET_VENUE_DATA,
        payload: {
            venueDataKey: dataKey,
            venueData
        }
    };
};

export const setSelectedVenue = (venueId: string) => {
    return {
        type: SELECTED_VENUE_ID,
        payload: venueId
    }
}